import React from 'react'

import { IconPropsType } from '../types'

const ShieldIcon = ({ className }: IconPropsType) => {
  return (
    <svg
      width='20'
      height='22'
      className={className}
      viewBox='0 0 20 22'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M19.0853 4.22317C19.0021 4.12818 18.9002 4.05137 18.7859 3.99756C18.6717 3.94376 18.5476 3.9141 18.4214 3.91046C16.4605 3.85919 13.9793 1.76248 12.3389 0.93968C11.3255 0.433016 10.6565 0.0989418 10.1541 0.0109377C10.0521 -0.00392686 9.94847 -0.00363895 9.84654 0.0117921C9.34415 0.0997962 8.67515 0.43387 7.66267 0.940534C6.02221 1.76248 3.54101 3.85919 1.58014 3.91046C1.45383 3.91429 1.32966 3.94402 1.21531 3.99782C1.10097 4.05161 0.998892 4.12831 0.915409 4.22317C0.742368 4.41895 0.653087 4.67482 0.666776 4.93575C1.088 13.4995 4.1596 18.7994 9.54921 21.8795C9.68933 21.959 9.84483 22 9.99948 22C10.1541 22 10.3096 21.959 10.4506 21.8795C15.8402 18.7994 18.911 13.4995 19.333 4.93575C19.3475 4.67486 19.2585 4.4188 19.0853 4.22317ZM14.7996 7.59125L10.2515 14.3026C10.0883 14.5436 9.83202 14.7034 9.57826 14.7034C9.32365 14.7034 9.04084 14.5641 8.86226 14.3855L5.65652 11.1789C5.55186 11.0739 5.49309 10.9316 5.49309 10.7833C5.49309 10.635 5.55186 10.4928 5.65652 10.3877L6.44856 9.59399C6.55383 9.48974 6.696 9.43126 6.84415 9.43126C6.99231 9.43126 7.13447 9.48974 7.23974 9.59399L9.3245 11.6787L12.9463 6.33271C13.0301 6.21037 13.1589 6.12616 13.3046 6.09847C13.4503 6.07077 13.601 6.10184 13.7239 6.1849L14.6509 6.81374C14.7734 6.89741 14.8577 7.02615 14.8856 7.17183C14.9135 7.31751 14.8825 7.4683 14.7996 7.59125Z'
        fill='currentColor'
      />
    </svg>
  )
}

export default ShieldIcon
